import { defineMeta } from '@/registry/types';

export const popoverMeta = defineMeta({
  name: 'Popover',
  level: 'molecule',
  category: 'feedback',
  classification: 'themed-mui',
  description: 'Contextual overlay anchored to an element for rich content. Themed MUI Popover.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Popover',
  muiDocs: 'https://mui.com/material-ui/react-popover/',
  a2uiEquivalent: 'Popover',
  importPath: '@/molecules/Popover',
  requiredProps: ['open', 'anchorEl'],
  optionalProps: ['onClose', 'anchorOrigin', 'transformOrigin'],
  supportedStates: ['open', 'closed'],
  designTokens: ['colors', 'radius', 'shadows', 'typography'],
  accessibility: ['Manages focus trapping; Esc closes; returns focus to anchor.'],
  usageExamples: [
    '<Popover open anchorEl={el} onClose={close}><Typography variant="subtitle2">prod-db-01</Typography><Typography variant="body1">Keep this short.</Typography></Popover>',
  ],
  rules: ['Heading is `subtitle2`; supporting copy is `body1`. Do not drop unstyled text into the popover.'],
  antiPatterns: ['Do not put long forms in a Popover (use Dialog/Drawer).'],
  mountsSurface: 'portal',
  llmSafe: true,
  whenToUse: ['Rich hover/click detail cards', 'Color pickers, mini-forms'],
  whenNotToUse: ['Simple text hints (use Tooltip)'],
});

export default popoverMeta;
